export const docUndefinedIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17.759 13.45V4.824c0-.264-.032-.46-.19-.618L13.558.194a.65.65 0 0 0-.458-.19H3.095c-.409 0-.849.316-.849 1.009V13.45zM12.933 1.174c0-.158.191-.237.302-.125l3.48 3.48c.112.112.033.302-.125.302h-3.657zM2.246 14.139v5.171c0 .348.421.689.849.689H16.91c.429 0 .849-.342.849-.689v-5.171z"/></svg>`,
  name: 'doc-undefined',
};
